import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { getEunaOrangeColor } from '../../utils/utilFunctions';

const ListItem = ({ item, index }) => {
	const location = useLocation();
	const [isSelected, setIsSelected] = useState(false);

	useEffect(() => {
		setIsSelected(location.pathname.includes(item?.linkTo || 'undefined'));
	}, [location]);

	return (
		<Link
			data-testid={`sidenav-list-link-${index}`}
			to={item?.linkTo || ''}
			style={{ textDecoration: 'none', color: 'black' }}
		>
			<ListItemButton
				sx={{
					pl: 3,
					borderRight: isSelected && `2px solid ${getEunaOrangeColor()}`
				}}
				data-testid={`sidenav-list-button-${index}`}
				selected={isSelected}
			>
				<ListItemIcon>{item?.icon}</ListItemIcon>
				<ListItemText data-testid={`sidenav-list-text-${index}`} primary={item.title} />
			</ListItemButton>
		</Link>
	);
};

export default ListItem;
